import { AdCtaGrid } from '@/components/AdGrid';
import { AdCtaItem, AdItem } from '@/components/AdItem';
import { Section } from '@/components/Section';
import { useWindowSize } from '@/hooks/useWindowSize';
import type { AdItemType, AdType } from '@/resource/ad';
import { TABLET_LANDSCAPE, TABLET_PORTRAIT } from '@/util/breakpoints';

export function RelevantAds({
  ads,
  adType,
}: {
  ads: AdItemType[];
  adType: AdType;
}) {
  const { width } = useWindowSize();

  let count = 4;
  if (width >= TABLET_LANDSCAPE) {
    count = 4;
  } else if (width >= TABLET_PORTRAIT) {
    count = 3;
  }

  const visible = ads.slice(0, count);

  return (
    <Section theme={4}>
      <h2>In de omgeving</h2>
      <AdCtaGrid>
        {visible.map((item) => (
          <AdItem item={item} key={item.id} theme={0} />
        ))}

        {visible.length < count && (
          <AdCtaItem type={adType} to={{ type: `add_${adType}` }} theme={0} />
        )}
      </AdCtaGrid>
    </Section>
  );
}
